import {RemotePostConfirmRegistrationData} from 'data/usecases/private/home/remote-post-confirm-registration-data';
import {PostConfirmRegistrationData} from 'domain/usecases/private/home/post-confirm-registration-data';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {HomeEndPoints} from 'main/factories/usecases/endpoints';

export const makePostConfirmRegistrationData = (): PostConfirmRegistrationData =>
	new RemotePostConfirmRegistrationData(
		makeBFFApiUrl(HomeEndPoints.registrationUpdateConfirm),
		makeAuthorizeHttpClientDecorator(),
	);
